import { Card, CardMedia, Typography, Box } from '@mui/material';
import React from 'react';
import './PromoVideo.css';
import Promo from '../../assets/promo-video/promo.mp4';

const PromoVideo = ({ title }) => {
  return (
    <Box className="promo-video-section">
      <Typography variant="h5" className="video-title">
        {title}
      </Typography>
      <Card className="video-container">
        <video
          className="promo-video"
          src={Promo}
          controls
          controlsList="nodownload"
        />
      </Card>

    </Box>
  );
};

export default PromoVideo;
